<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <div class="flex justify-center">
      <work-ui-logo />
    </div>

    <div class="padding-vertical-24">
      <h1 class="work-text-align-center">{{ 'SMS_CODE' | translate }}</h1>
      <p class="work-text-align-center">
        {{ 'SMS_CODE_EINGEBEN_HINWEIS' | translate }}
      </p>
    </div>

    <form [formGroup]="formGroup" autocomplete="off">
      <work-ui-input-field
        formControlName="otp"
        label="SMS_CODE"
        type="number"
        inputmode="numeric"
        autocomplete="one-time-code"
        placeholder="SMS_CODE"
        [required]="true"
      ></work-ui-input-field>

      <work-ui-button
        text="WEITER"
        variant="primary"
        type="submit"
        [fullWidth]="true"
        [disabled]="!formGroup.controls.otp.valid"
        (buttonClick)="verifyOtp()"
      ></work-ui-button>
    </form>
  </div>
</ion-content>
